module.exports = function() {
  return require('lodash').cloneDeep(require('./defaultConfig.stub.js'))
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/tailwindcss/defaultConfig.js
// module id = G/gL
// module chunks = 3